// extracted by mini-css-extract-plugin
module.exports = {"container":"Privacy_container__3K4l3","tar":"Privacy_tar__3Iolo","note":"Privacy_note__2004r"};